/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_0_TitleInputs */

const en_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grass Tees`)
};

const es_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puestos de césped natural`)
};

const de_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasenabschläge`)
};

const zh_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天然草皮打位`)
};

const ar_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منصات ضرب عشبية`)
};

const fr_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postes sur gazon`)
};

const vi_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ô phát bóng trên cỏ`)
};

const sw_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehemu za kupigia kwenye nyasi`)
};

const th_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จุดตีบนหญ้า`)
};

const bs_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mjesta za udarce na travi`)
};

const ja_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天然芝打席`)
};

const ko_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`천연 잔디 타석`)
};

const pt_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baias de grama natural`)
};

const it_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postazioni su erba`)
};

const sv_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gräsutslagsplatser`)
};

const nl_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasafslagplaatsen`)
};

const da_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Græsudslagssteder`)
};

const nb_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gressutslagsplasser`)
};

const fi_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nurmilyöntipaikat`)
};

const pl_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stanowiska na trawie`)
};

const ru_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки с натуральной травой`)
};

const tr_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çim atış noktaları`)
};

const hi_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घास वाले टी`)
};

const id_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat pukul rumput`)
};

const ms_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petak pukulan berumput`)
};

const cs_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpaliště na trávě`)
};

const el_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θέσεις σε γρασίδι`)
};

const he_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עמדות חבטה על דשא`)
};

const af_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasafslaanplekke`)
};

const hu_range_content_feature_0_title = /** @type {(inputs: Range_Content_Feature_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füves elütőhelyek`)
};

/**
* | output |
* | --- |
* | "Grass Tees" |
*
* @param {Range_Content_Feature_0_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_0_title = /** @type {((inputs?: Range_Content_Feature_0_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_0_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_0_title(inputs)
	if (locale === "de") return de_range_content_feature_0_title(inputs)
	if (locale === "zh") return zh_range_content_feature_0_title(inputs)
	if (locale === "ar") return ar_range_content_feature_0_title(inputs)
	if (locale === "fr") return fr_range_content_feature_0_title(inputs)
	if (locale === "vi") return vi_range_content_feature_0_title(inputs)
	if (locale === "sw") return sw_range_content_feature_0_title(inputs)
	if (locale === "th") return th_range_content_feature_0_title(inputs)
	if (locale === "bs") return bs_range_content_feature_0_title(inputs)
	if (locale === "ja") return ja_range_content_feature_0_title(inputs)
	if (locale === "ko") return ko_range_content_feature_0_title(inputs)
	if (locale === "pt") return pt_range_content_feature_0_title(inputs)
	if (locale === "it") return it_range_content_feature_0_title(inputs)
	if (locale === "sv") return sv_range_content_feature_0_title(inputs)
	if (locale === "nl") return nl_range_content_feature_0_title(inputs)
	if (locale === "da") return da_range_content_feature_0_title(inputs)
	if (locale === "nb") return nb_range_content_feature_0_title(inputs)
	if (locale === "fi") return fi_range_content_feature_0_title(inputs)
	if (locale === "pl") return pl_range_content_feature_0_title(inputs)
	if (locale === "ru") return ru_range_content_feature_0_title(inputs)
	if (locale === "tr") return tr_range_content_feature_0_title(inputs)
	if (locale === "hi") return hi_range_content_feature_0_title(inputs)
	if (locale === "id") return id_range_content_feature_0_title(inputs)
	if (locale === "ms") return ms_range_content_feature_0_title(inputs)
	if (locale === "cs") return cs_range_content_feature_0_title(inputs)
	if (locale === "el") return el_range_content_feature_0_title(inputs)
	if (locale === "he") return he_range_content_feature_0_title(inputs)
	if (locale === "af") return af_range_content_feature_0_title(inputs)
	if (locale === "hu") return hu_range_content_feature_0_title(inputs)
	return en_range_content_feature_0_title(inputs)
});